// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.order.devicemeasurement.AssociateMeasurementWithOrderRequest */
/* istanbul ignore next */
@GandalfModel
export class AssociateMeasurementWithOrderRequest extends GandalfModelBase {

	@GandalfLabel('Device Measurement')
	@GandalfValidator({ notNull: { message: 'Device Measurement is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	deviceMeasurementId!: number;

	@GandalfLabel('Order')
	@GandalfValidator({ notNull: { message: 'Order is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	orderId!: number;

	@GandalfLabel('Patient')
	@GandalfProperty({ designType: Number })
	patientId!: number;

}
